module.exports = __webpack_public_path__ + "img/no-feed.b35c084e.svg";